import axios from 'axios';
import { BASE_URL } from './constants';

export const getResources = (language = 'en', country = 'en') => {
    return axios.get(`${BASE_URL}/pages/resources`, {
        params: {
            language,
            country,
        },
    });
};

export const getProducts = (language = 'en', country = 'en') => {
    return axios.get(`${BASE_URL}/pages/resources`, {
        params: {
            language,
            country,
        },
    });
};

export const getCropNutrition = (language = 'en', country = 'en') => {
    return axios.get(`${BASE_URL}/pages/resources/crop-nutrition-programs`, {
        params: {
            language,
            country,
        },
    });
};

export const getTrialResults = (language = 'en', country = 'en') => {
    return axios.get(`${BASE_URL}/pages/resources/trial-results`, {
        params: {
            language,
            country,
        },
    });
};
